import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// slices
import userReducer from './slices/user';
import vehicleReducer from './slices/vehicle';
import companyReducer from './slices/company';
import brandReducer from './slices/brand';
import branchReducer from './slices/branch';
import leadReducer from './slices/lead';
import searchReducer from './slices/search';
import redbookReducer from './slices/redbook';
import pdfReducer from './slices/pdf';
import systemReducer from './slices/system';

import productReducer from './slices/product';
import authJwtReducer from './slices/authJwt';
import settingsReducer from './slices/settings';
import pricingRequestReducer from './slices/pricingRequest';

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['settings']
};

const productPersistConfig = {
  key: 'product',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout']
};

const authPersistConfig = {
  key: 'authJwt',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['isAuthenticated']
};

const userPermissionPersistConfig = {
  key: 'userPermission',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['userPermissions']
};

const rootReducer = combineReducers({
  user: persistReducer(userPermissionPersistConfig, userReducer),
  vehicle: vehicleReducer,
  company: companyReducer,
  brand: brandReducer,
  branch: branchReducer,
  lead: leadReducer,
  search: searchReducer,
  redbook: redbookReducer,
  pdf: pdfReducer,
  settings: settingsReducer,
  pricingRequest: pricingRequestReducer,
  system: systemReducer,
  product: persistReducer(productPersistConfig, productReducer),
  authJwt: persistReducer(authPersistConfig, authJwtReducer)
});

export { rootPersistConfig, rootReducer };
